import React from "react";
import Svg, { Path } from "react-native-svg";

const AddUserIcon = ({ color = "" }) => {
  return (
    <Svg
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M17.5 10C20.2625 10 22.5 7.7625 22.5 5C22.5 2.2375 20.2625 0 17.5 0C14.7375 0 12.5 2.2375 12.5 5C12.5 7.7625 14.7375 10 17.5 10ZM6.25 7.5V5C6.25 4.3125 5.6875 3.75 5 3.75C4.3125 3.75 3.75 4.3125 3.75 5V7.5H1.25C0.5625 7.5 0 8.0625 0 8.75C0 9.4375 0.5625 10 1.25 10H3.75V12.5C3.75 13.1875 4.3125 13.75 5 13.75C5.6875 13.75 6.25 13.1875 6.25 12.5V10H8.75C9.4375 10 10 9.4375 10 8.75C10 8.0625 9.4375 7.5 8.75 7.5H6.25ZM17.5 12.5C14.1625 12.5 7.5 14.175 7.5 17.5V18.75C7.5 19.4375 8.0625 20 8.75 20H26.25C26.9375 20 27.5 19.4375 27.5 18.75V17.5C27.5 14.175 20.8375 12.5 17.5 12.5Z"
        fill={color}
      />
    </Svg>
  );
};

export default AddUserIcon;
